/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';
import './inc/responsive-menus';
import { addMarginToSiteInner, stickyHeader } from './inc/header/sticky-header';
// import './inc/confetti';
import './inc/gform/gform';
import './inc/in-view';
import './inc/modal/open-modal';
import './inc/popup/open-popup';
import './inc/author-posts-ajax';
import stickySidebar from './inc/fixed-sidebar-on-scroll';
import menuSearchForm from './inc/menu-search-form';

function initPopoverSlider($popover) {
  const $slider = $popover.find('.testimonial-slider-top .slides');
  if (!$slider.length) return;

  // The reviews popover lives in every page header, but slick is
  // conditionally enqueued via has_any_block() on the slick blocks
  // (logos / testimonials / post-query / etc.). On pages without any of
  // those blocks slick isn't loaded, and calling .slick() here throws
  // "$slider.slick is not a function" which then halts the rest of the
  // wp-load callback (sticky header, menu search, etc.). Bail silently
  // when slick is unavailable — the popover still opens/closes via the
  // class-toggle path; it just won't auto-rotate.
  if (typeof $.fn.slick !== 'function') return;

  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 400,            // snappier open
      slidesToShow: 1,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 5000,
      cssEase: 'ease',
    });
  }
}

function openPopover($popover) {
  // close any other open popovers
  $('.top-bar-reviews-popover.is-open').not($popover).removeClass('is-open');

  // show via class (no jQuery fadeIn to avoid fighting CSS animations)
  $popover.addClass('is-open');

  // after it's visible, ensure slick recalculates widths to avoid snap
  requestAnimationFrame(() => {
    const $slider = $popover.find('.testimonial-slider-top .slides.slick-initialized');
    if ($slider.length) $slider.slick('setPosition');
  });
}

function closePopover($popover) {
  $popover.removeClass('is-open');
}

$(window).on('load', () => {
  if (document.body.classList.contains('page-id-6692')) {
    return;
  }

  stickyHeader.init();
  menuSearchForm.init();

  if (document.body.classList.contains('single-post')) {
    stickySidebar.init();
  }

  // PREPARE: initialize all popover sliders once.
  // Important: CSS should keep popover display:block but invisible (opacity/visibility),
  // so Slick can measure widths.
  $('.top-bar-reviews-popover').each(function () {
    initPopoverSlider($(this));
  });

  // OPEN handler (delegated)
  $(document).on('click', '.top-reviews a', function (e) {
    e.preventDefault();

    const $container = $(this).closest('.top-reviews');
    const $popover = $container.find('.top-bar-reviews-popover');

    // if small screens, hide menus to prevent layout shifts/scrollbar flicker
    if (window.innerWidth <= 630) {
      $('.menu-bar, .mobile-nav').hide();
    }

    openPopover($popover);

    // outside click to close
    $(document)
      .off('mousedown.reviewsPopover')
      .on('mousedown.reviewsPopover', function (event) {
        if (
          !$popover.is(event.target) &&
          $popover.has(event.target).length === 0 &&
          !$(event.target).closest('.top-reviews a').length
        ) {
          closePopover($popover);
          if (window.innerWidth <= 630) {
            $('.menu-bar, .mobile-nav').show();
          }
          $(document).off('mousedown.reviewsPopover');
        }
      });
  });
});

$(window).on('resize', () => {
  menuSearchForm.init();
});

window.addEventListener('resize', addMarginToSiteInner);
window.addEventListener('DOMContentLoaded', addMarginToSiteInner);

// window.addEventListener('DOMContentLoaded', () => {
//   console.log('dom content loaded');
//   document.querySelectorAll('*').forEach((el) => {
//     if (el.offsetWidth > document.documentElement.offsetWidth) {
//       console.log('Found the worst element ever: ', el);
//     }
//   });
// });
